<template>
  <v-data-table
    :headers="tabela.headers"
    :items="relatoriosPreferencias"
    :search="tabela.opcoes.pesquisa"
    :sort-by="tabela.opcoes.ordenarPor"
    :sort-desc="tabela.opcoes.decrescente"
    item-key="id"
    show-expand
    single-expand
  >
    <!-- Ordenação e Pesquisa -->
    <template v-slot:top>
      <v-row>
        <v-col cols="12" md="4">
          <app-sort v-model="tabela.opcoes" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="4">
          <app-search v-model="tabela.opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- Respostas (Botão de Expansão) -->
    <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            height="100%"
            text
            width="100%"
            @click="expand(!isExpanded)"
            v-on="on"
          >
            <v-badge right>
              <template v-slot:badge>
                <span>{{ item.itemA.quantidade }}</span>
              </template>
              <h1 class="h1 grey--text">A</h1>
            </v-badge>
            <v-badge right>
              <template v-slot:badge>
                <span>{{ item.itemB.quantidade }}</span>
              </template>
              <h1 class="h1 grey--text ml-8">B</h1>
            </v-badge>
          </v-btn>
        </template>
        <span>Clique para exibir as repostas</span>
      </v-tooltip>
    </template>

    <!-- Respostas (Lista Expandida) -->
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="justify-center">
        <v-row dense>
          <v-spacer />
          <v-col>
            <v-row class="justify-center">
              <app-title texto="RESPOSTAS" />
            </v-row>
          </v-col>
          <v-spacer />
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="10">
            <component
              :is="isGeral ? 'ExpansaoGeral' : 'ExpansaoUnidade'"
              :item-a="item.itemA"
              :item-b="item.itemB"
              :respostas="item.respostas"
            />
          </v-col>
          <v-spacer />
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import ExpansaoGeral from './ExpansaoResultadoGeralPreferencia';
import ExpansaoUnidade from './ExpansaoResultadoUnidadePreferencia';

export default {
  name: 'TabelaResultadoPreferencia',

  components: {
    AppTitle,
    AppSort,
    AppSearch,
    ExpansaoGeral,
    ExpansaoUnidade,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isGeral: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tabela: {
        headers: [
          { text: 'PREFERÊNCIA DE TRABALHO', value: 'preferencia', sortable: false },
          {
            text: 'RESPOSTAS',
            value: 'data-table-expand',
            width: '10%',
            align: 'center',
          },
        ],
        opcoes: {
          pesquisa: '',
          decrescente: false,
          ordenarPor: 'preferencia',
          selecionado: { id: 'preferencia', descricao: 'Preferência de Trabalho' },
          lista: [
            { id: 'preferencia', descricao: 'Preferência de Trabalho' },
            { id: 'itemA.quantidade', descricao: 'Resposta A' },
            { id: 'itemB.quantidade', descricao: 'Resposta B' },
          ],
        },
      },
    };
  },

  computed: {
    relatoriosPreferencias() {
      return this.relatorio.preferencias.map((p) => ({
        id: p.id,
        preferencia: `${p.ordem}. ${p.nome}`,
        itemA: p.itemA,
        itemB: p.itemB,
        respostas: this.getRespostas(p),
      }));
    },
  },

  methods: {
    getRespostas(preferencia) {
      if (this.isGeral) {
        return this.relatorio.unidades.map((relatorioUnidade) => {
          const preferenciaUnidade = relatorioUnidade.preferencias.find((p) => p.id === preferencia.id);
          return {
            id: relatorioUnidade.id,
            nome: relatorioUnidade.nome,
            sigla: relatorioUnidade.sigla,
            itemA: preferenciaUnidade ? preferenciaUnidade.itemA.quantidade : 0,
            itemB: preferenciaUnidade ? preferenciaUnidade.itemB.quantidade : 0,
          };
        }).sort((a, b) => a.nome.localeCompare(b.nome));
      }
      return this.relatorio.perfis.map((relatorioPerfil) => {
        const preferenciaPerfil = relatorioPerfil.preferencias.find((p) => p && p.id === preferencia.id);
        return {
          id: relatorioPerfil.id,
          servidor: relatorioPerfil.servidor,
          itemEscolhido: preferenciaPerfil ? preferenciaPerfil.itemEscolhido : null,
        };
      }).sort((a, b) => a.servidor.localeCompare(b.servidor));
    },
  },
};
</script>
